import { hiDPI, size } from "polished";
import styled, { css } from "styled-components";
import BaseFantasyLogo from "../../img/fantasy-logo.svg?react";
import Background from "../../img/headerbackground@1.5x.png";
import Background2x from "../../img/headerbackground@2x.png";
import playerComp175 from "../../img/player-comp-175.png";
import playerComp345 from "../../img/player-comp-345.png";
import playerComp460 from "../../img/player-comp-460.png";
import playerComp690 from "../../img/player-comp-690.png";

interface ILocaleStyles {
  rtl: boolean;
}

export const GameHeaderOuter = styled.header<ILocaleStyles>`
  position: relative;
  background-color: ${(props) => props.theme.colors.white};
  filter: drop-shadow(0px 0px 4px ${(props) => props.theme.colors.greyLight});

  @media (min-width: ${(props) => props.theme.breakpoints[3]}) {
    background-image: url(${Background});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    ${(props) =>
      props.rtl &&
      css`
        background-position: left;
      `}

    ${hiDPI(2)} {
      background-image: url(${Background2x});
    }
  }
`;

export const BorderTop = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 30px;
  background-image: linear-gradient(
    to right,
    ${(props) => props.theme.colors.red} 10%,
    ${(props) => props.theme.colors.pink}
  );
`;

export const BorderBottom = styled.div`
  background-image: linear-gradient(
    to right,
    ${(props) => props.theme.colors.blueDark} 75%,
    ${(props) => props.theme.colors.blue}
  );
  position: absolute;
  bottom: 0;
  width: 100%;
`;

export const GameHeaderInner = styled.div<ILocaleStyles>`
  position: relative;
  max-width: 1220px;
  margin: 0 auto;
  padding: 0 ${(props) => props.theme.space[2]};
  background-image: url(${playerComp175});
  background-size: 180px auto;
  background-position: right 20px bottom 0px;
  background-repeat: no-repeat;

  ${(props) =>
    props.rtl &&
    css`
      background-position: left 35px bottom 0px;
    `}

  ${hiDPI(2)} {
    background-image: url(${playerComp345});
  }

  @media (min-width: ${(props) => props.theme.breakpoints[1]}) {
    background-image: url(${playerComp460});
    background-position: right 100px bottom 0px;
    background-size: 190px auto;
    ${(props) =>
      props.rtl &&
      css`
        background-position: left 100px bottom 0px;
      `}

    ${hiDPI(2)} {
      background-image: url(${playerComp690});
    }
  }

  @media (min-width: ${(props) => props.theme.breakpoints[3]}) {
    padding: 0 ${(props) => props.theme.space[4]};
    background-position: right 110px bottom 0px;
    background-size: 310px auto;
    ${(props) =>
      props.rtl &&
      css`
        background-position: left 150px bottom 0px;
      `}
  }
`;

export const GameTitle = styled.h1`
  margin: 0;
  padding: 3.5rem 0 1rem;

  @media (min-width: ${(props) => props.theme.breakpoints[3]}) {
    padding: 2.5rem 0 2rem;
  }
`;

export const FantasyLogo = styled(BaseFantasyLogo)`
  ${size(75, 149)}

  @media (min-width: ${(props) => props.theme.breakpoints[3]}) {
    ${size(150, 325)}
  }
`;

export const GameHeaderWrapper = styled.div`
  position: relative;
  z-index: 2;
`;

export const StickyNavigationWrap = styled.div<{ $site?: string }>`
  position: sticky;
  top: ${({ $site }) =>
    $site === "sport5" ? "69px" : $site === "lequipe" ? "48px" : "0"};
  z-index: ${({ theme }) => theme.zIndex.menu};

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    position: ${({ $site }) =>
      $site === "sport5" || $site === "lequipe" ? "sticky" : "relative"};
  }
`;
